







import Vue from 'vue'
import { inIOS } from 'vtils'
import { pxToRem } from '@/utils'

export default Vue.extend({
  props: {
    unit: {
      type: String,
      default: '¥',
    },
    value: {
      type: [Number, String],
      required: true,
    },
    unitSize: {
      type: Number,
      required: true,
    },
    valueSize: {
      type: Number,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    isIOS: inIOS(),
  }),

  computed: {
    _unitSize(): string {
      return `${pxToRem(this.unitSize)}rem`
    },
    _valueSize(): string {
      return `${pxToRem(this.valueSize)}rem`
    },
  },
})
